import * as React from 'react';

import Grid, { GridProps } from '@mui/material/Grid';

export type PageContainerProps = {
  children?: React.ReactNode;
} & GridProps;

export const PageContainer: React.FC<PageContainerProps> = ({ children, ...props }) => {
  return (
    <Grid
      {...props}
      container
      flexWrap="nowrap"
      gap={4}
      marginX={'auto'}
      mt={3}
      paddingX={{ sm: 2, xs: 1 }}
      pb={4}
      sx={{ maxWidth: '1280px', minHeight: 'calc(100dvh - 140px)', width: '100%', ...props?.sx }}
    >
      {children}
    </Grid>
  );
};
